import React, { useState } from "react";
import { postUpdateFixturesJob, postUpdateScoresJob } from "../../api/jobs";
import { AlertUserSessionExpiredToken } from "../../components/AlertUserSessionExpiredToken";
import {
	toastError,
	toastInfo,
} from "../../helpers/notificationHelpers";

const initialTaskState = {
	isManual: true,
	loading: false,
	error: "",
};

function ScheduledTasksPage() {
	const [updateFixturesTask, setUpdateFixturesTask] = useState(initialTaskState);
	const [updateScoresTask, setUpdateScoresTask] = useState(initialTaskState);

	const handleTaskOptionChange = (setTaskState) => (event) => {
		const { checked } = event.target;

		setTaskState((currentState) => ({
			...currentState,
			isManual: checked,
		}));
	};

	const executeTask = async ({
		apiCall,
		taskLabel,
		taskState,
		setTaskState,
	}) => {
		setTaskState((currentState) => ({
			...currentState,
			loading: true,
			error: "",
		}));

		try {
			const response = await apiCall({ isManual: taskState.isManual });

			if (response?.status === 200) {
				toastInfo(`${taskLabel} ejecutado correctamente.`);
				setTaskState((currentState) => ({
					...currentState,
					loading: false,
					error: "",
				}));
				return;
			}

			const errorMessage = `Error al ejecutar ${taskLabel.toLowerCase()}.`;
			toastError(errorMessage);
			setTaskState((currentState) => ({
				...currentState,
				loading: false,
				error: errorMessage,
			}));
		} catch (error) {
			const errorMessage = `Error al ejecutar ${taskLabel.toLowerCase()}.`;
			toastError(errorMessage);
			setTaskState((currentState) => ({
				...currentState,
				loading: false,
				error: errorMessage,
			}));
		}
	};

	return (
		<React.Fragment>
			<div className='container py-4'>
				<AlertUserSessionExpiredToken />
				<div className='row mb-4'>
					<div className='col-12'>
						<h4>Tareas programadas</h4>
						<p className='mb-0'>
							Ejecuta manualmente los procesos de actualizacion de partidos y
							marcadores disponibles para administracion.
						</p>
					</div>
				</div>
				<div className='row g-4'>
					<div className='col-12 col-lg-6'>
						<div className='card h-100'>
							<div className='card-body'>
								<h5 className='card-title'>Actualizar partidos</h5>
								<p className='card-text'>
									Actualiza los partidos de los torneos en curso, creando
									nuevos fixtures o sincronizando los existentes.
								</p>
								<div className='form-check form-switch mb-3'>
									<input
										checked={updateFixturesTask.isManual}
										className='form-check-input'
										id='update-fixtures-is-manual'
										onChange={handleTaskOptionChange(setUpdateFixturesTask)}
										type='checkbox'
									/>
									<label
										className='form-check-label'
										htmlFor='update-fixtures-is-manual'
									>
										Enviar isManual
									</label>
								</div>
								{updateFixturesTask.error && (
									<div className='alert alert-danger' role='alert'>
										{updateFixturesTask.error}
									</div>
								)}
								<button
									className='btn btn-primary'
									disabled={updateFixturesTask.loading}
									onClick={() =>
										executeTask({
											apiCall: postUpdateFixturesJob,
											setTaskState: setUpdateFixturesTask,
											taskLabel: "Actualizar partidos",
											taskState: updateFixturesTask,
										})
									}
									type='button'
								>
									{updateFixturesTask.loading ? "Ejecutando..." : "Ejecutar"}
								</button>
							</div>
						</div>
					</div>
					<div className='col-12 col-lg-6'>
						<div className='card h-100'>
							<div className='card-body'>
								<h5 className='card-title'>Actualizar marcadores</h5>
								<p className='card-text'>
									Actualiza unicamente los marcadores de partidos ya
									finalizados.
								</p>
								<div className='form-check form-switch mb-3'>
									<input
										checked={updateScoresTask.isManual}
										className='form-check-input'
										id='update-scores-is-manual'
										onChange={handleTaskOptionChange(setUpdateScoresTask)}
										type='checkbox'
									/>
									<label
										className='form-check-label'
										htmlFor='update-scores-is-manual'
									>
										Enviar isManual
									</label>
								</div>
								{updateScoresTask.error && (
									<div className='alert alert-danger' role='alert'>
										{updateScoresTask.error}
									</div>
								)}
								<button
									className='btn btn-primary'
									disabled={updateScoresTask.loading}
									onClick={() =>
										executeTask({
											apiCall: postUpdateScoresJob,
											setTaskState: setUpdateScoresTask,
											taskLabel: "Actualizar marcadores",
											taskState: updateScoresTask,
										})
									}
									type='button'
								>
									{updateScoresTask.loading ? "Ejecutando..." : "Ejecutar"}
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</React.Fragment>
	);
}

export { ScheduledTasksPage };